module.exports = "---\r\nurl: \"https://petstore.swagger.io/v2/swagger.json\"\r\ndom_id: \"#swagger-ui\"\r\nvalidatorUrl: \"https://online.swagger.io/validator\"\r\noauth2RedirectUrl: \"http://localhost:3200/oauth2-redirect.html\"\r\n"


//////////////////
// WEBPACK FOOTER
// ./swagger-config.yaml
// module id = 934
// module chunks = 0